import React from 'react';
import { ButtonBase } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

import { chipSx, restingChipSx, selectedChipSx } from 'theme/chips';

export const ChoiceChip: React.FC<{
  selected: boolean;
  onClick: () => void;
  children: React.ReactNode;
}> = ({ selected, onClick, children }) => (
  <ButtonBase
    disableRipple
    aria-pressed={selected}
    onClick={onClick}
    sx={{ ...chipSx, ...(selected ? selectedChipSx : restingChipSx) }}
  >
    {children}
    <CheckIcon
      sx={{ fontSize: '0.75rem', flexShrink: 0, opacity: selected ? 1 : 0 }}
    />
  </ButtonBase>
);
